import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const adminGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const claims = await authService.getTokenClaims();

  // Must have a token with 'roles' claim containing 'admin'
  if (claims && Array.isArray(claims['roles']) && (claims['roles'] as string[]).includes('admin')) {
    return true;
  }

  return router.createUrlTree(['/login']);
};
